<template>
  <div>
      <retail-template :list="list" :selectName="selectName" @binditem="handlIntoDetail"></retail-template>
  </div>
</template>

<script>
import retailTemplate from './components/template'
export default {
  components:{retailTemplate},
  metaInfo: {
	        meta: [
	            {
	                name: 'keywords',
	                 content: '云伽未来,云伽智能,物联网,车联网,汽车智能终端,智能锁,智慧产品,NB-IoT,5G ,通讯,定位,共享单车锁,物联网,车联网,TBOX,OBD,车载智能终端,共享单车锁,智能锁,物联网企业,智慧出行,智慧空间,智慧物流,智慧零售,IN+智慧平台'
	            },
	            {
	                name: 'description',
	                content: '云伽智能,智慧产品,智慧零售'
	            }
	        ]
	    },
  data() {
    return {
       list:[
        {
          title:'无人零售货柜',
          path:'product-retail',
          name:'product-lingshou',
          desc:'智能新零售融合多种人工智能技术，提供无人值守，智能产品 体验，智能支付，以人工智能导购为核心的全新购物体验模式， 为消费者带来便捷、贴心和个性化的购物体验。',
          content:[
            {
              name:'无人零售货柜',
              img:require('../../assets/mobileImg/m-lingshou1.png'),
              pc_img:require('../../assets/image/lingshougui.png'),
              id:3
            }
          ]
        },
        {
          title:'商超购物车智能锁',
          path:'product-super',
          name:'product-Super',
          desc:'智能新零售融合多种人工智能技术，提供无人值守，智能产品 体验，智能支付，以人工智能导购为核心的全新购物体验模式， 为消费者带来便捷、贴心和个性化的购物体验。',
          content:[
             {
              name:'商超购物车智能锁',
              img:require('../../assets/mobileImg/m-lingshou2.png'),
              pc_img:require('../../assets/image/shangchao.png'),
              id:4,
            }
          ]
        }
      ],
       selectName:'智慧零售'
    };
  },
  methods: {
    handlIntoDetail(id) {
      this.$router.push({ name: "product", params: { id: id } });
      sessionStorage.setItem("id", id);
    },
  },
  mounted() {
  var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {
      var id = hash.substring(index + 1, hash.length + 1);
      var div = document.getElementById(id);
      if (div) {
        setTimeout(function() {
          $("html, body").animate(
            { scrollTop: $(div).offset().top - 78 },
            300
          );
        }, 300);
      }
    }
  },
  watch: {
    $route(to, from) {
      var hash = window.location.hash;
      var index = hash.lastIndexOf("#");
      if (index != -1) {
        var id = hash.substring(index + 1, hash.length + 1);
        var div = document.getElementById(id);
        if (div) {
          setTimeout(function() {
            $("html, body").animate(
              { scrollTop: $(div).offset().top - 78 },
              300
            );
          }, 300);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/smartProduct/Retail.vue